import { AbstractControl, ValidatorFn } from '@angular/forms';

export function dateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) {
      return null; // don't validate empty values to allow optional controls
    }

    const datePattern = /^\d{2}\.\d{2}\.\d{4}$/;
    // console.log('control.value',control.value);
    
    if (!datePattern.test(control.value)) {
      return { invalidDate: true };
    }

    const [day, month, year] = control?.value?.split('.')?.map(Number);

    if (day < 1 || day > 31 || month < 1 || month > 12) {
      return { invalidDate: true };
    }

    return null;
  };
}
